<template>
 <ul class="pagination justify-content-end mb-5">

  <!-- Prev (RTL) -->
  <li>
    <a href="#" title="السابق" @click.prevent="changePage(prevPage)">«</a>
  </li>

  <!-- Last pages -->
  <li v-for="p in lastPages" :key="'l' + p">
    <a href="#" @click.prevent="changePage(p)">{{ p }}</a>
  </li>

  <!-- Dots -->
  <li v-if="showEndDots">
    <span class="pagination-dots">...</span>
  </li>

  <!-- Middle -->
  <li v-for="p in middlePages" :key="'m' + p">
    <a href="#" :class="{ active: p === data.current_page }"
       @click.prevent="changePage(p)">
      {{ p }}
    </a>
  </li>

  <!-- Dots -->
  <li v-if="showStartDots">
    <span class="pagination-dots">...</span>
  </li>

  <!-- First -->
  <li v-if="!isSmallPagination">
  <a href="#" @click.prevent="changePage(1)">1</a>
</li>


  <!-- Next (RTL) -->
  <li>
    <a href="#" title="التالى" @click.prevent="changePage(nextPage)">»</a>
  </li>



</ul>

</template>

<script>
   export default {
  props: {
    data: { type: Object, required: true }
  },
computed: {
    isSmallPagination() {
    return this.data.last_page <= 3;
  },

 middlePages() {
  // ✅ SMALL CASE (1–3 pages)
  if (this.isSmallPagination) {
    const pages = [];
    for (let i = this.data.last_page; i >= 1; i--) {
      pages.push(i); // RTL-safe order
    }
    return pages;
  }

  // ✅ NORMAL CASE
  const range = 3;
  let start = Math.max(this.data.current_page - range, 2);
  let end = Math.min(this.data.current_page + range, this.data.last_page - 3);

  const pages = [];
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages.reverse(); // RTL fix
},

lastPages() {
  if (this.isSmallPagination) return [];

  const last = this.data.last_page;
  return [last, last - 1, last - 2];
},

 showStartDots() {
  if (this.isSmallPagination) return false;

  return this.middlePages.length &&
         this.middlePages[this.middlePages.length - 1] > 2;
},

showEndDots() {
  if (this.isSmallPagination) return false;

  return this.middlePages.length &&
         this.middlePages[0] < this.data.last_page - 3;
},

  prevPage() {
    return Math.max(this.data.current_page - 1, 1);
  },

  nextPage() {
    return Math.min(this.data.current_page + 1, this.data.last_page);
  }
},

  methods: {
    changePage(page) {
      this.$emit('getIndexData', page);
    }
  }
};

</script>
<style>
 .pagination {
  display: flex;
  flex-wrap: nowrap;
  direction: ltr;
  gap: 4px;
}

.pagination-dots {
  min-width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 6px;
  pointer-events: none;
}

</style>